// Convert CMS phone numbers and social handles into external links.
export function socialLink(key, value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) return raw;
  if (/^\/\//.test(raw)) return "https:" + raw;
  if (/^[a-z][a-z0-9+.-]*:/i.test(raw)) return "";
  if (key.startsWith("whatsapp")) {
    const digits = raw.replace(/\D/g, "");
    return /^\d{6,15}$/.test(digits) ? "https://wa.me/" + digits : "";
  }
  const platforms = {
    instagram: "www.instagram.com/",
    facebook: "www.facebook.com/",
    tiktok: "www.tiktok.com/@",
    linktree: "linktr.ee/",
  };
  if (platforms[key]) {
    const host = {instagram:"instagram.com",facebook:"facebook.com",tiktok:"tiktok.com",linktree:"linktr.ee"}[key];
    if (raw.toLowerCase().startsWith(host + "/") || raw.toLowerCase().startsWith("www." + host + "/")) return "https://" + raw;
    const handle = raw.replace(/^@/, "");
    return /^[a-z0-9_.-]+$/i.test(handle) ? "https://" + platforms[key] + handle : "";
  }
  return /^[a-z0-9.-]+\.[a-z]{2,}(?:[/?#][^\s]*)?$/i.test(raw) ? "https://" + raw : "";
}
